import { translate } from "@jsverse/transloco";
import { Organization, Recipient } from "app/main/pages/edit-template/edit-template.dto";


/**
 * Search recipient with multiple columns
 * @param items 
 * @param query 
 * @returns 
 */
export function searchRecipientCustomFilter(items: Recipient[], query: string){
  const results = [];
  items.forEach(
      (item) => {
          if (Object.values(item).some(value => typeof value === 'string' && value.toLowerCase().includes(query.toLowerCase()))) {
              results.push(item);
          }
      }
  );
  results.push({ id: 0, name: '', suggest_name: translate("Auto complete text (Template/Document - section) - Add query as recipient", {query:query}), fullname: query });
  return results;
}



/**
 * Search organization with multiple columns
 * @param items 
 * @param query 
 * @returns 
 */
export function searchOrganizationCustomFilter(items: Organization[], query: string){
  const results = [];
  items.forEach(
      (item) => {
          if (Object.values(item).some(value => typeof value === 'string' && value.toLowerCase().includes(query.toLowerCase()))) {
              results.push(item);
          }
      }
  );
  results.push({ id: 0, name: query, fullname: translate("Auto complete text (Template/Document - section) - Add query as an organization", {query:query}) });
  return results;
}